// extracted by mini-css-extract-plugin
module.exports = {"button_wrapper":"NoConnectionError_button_wrapper__3rWll","button_reload":"NoConnectionError_button_reload__2zN52"};